module.exports = __webpack_public_path__ + "static/media/hall2.4d23717c.jpg";